/*
 * <cart-addon> — one-tap "add a panel for a friend" upsell inside the cart drawer.
 * Adds the add-on variant via /cart/add.js, then re-renders the drawer using the
 * theme's existing cart-drawer machinery (same flow product-form.js uses).
 */
if (!customElements.get('cart-addon')) {
  customElements.define(
    'cart-addon',
    class CartAddon extends HTMLElement {
      constructor() {
        super();
        this.button = this.querySelector('[data-cart-addon-add]');
        this.variantId = this.dataset.variantId;
        this.max = parseInt(this.dataset.max, 10) || 10;
        this.qty = 1;

        this.input = this.querySelector('[data-cart-addon-qty]');
        this.minusBtn = this.querySelector('[data-cart-addon-minus]');
        this.plusBtn = this.querySelector('[data-cart-addon-plus]');
      }

      connectedCallback() {
        if (!this.button || !this.variantId) return;

        this.button.addEventListener('click', this.onClick.bind(this));
        this.minusBtn && this.minusBtn.addEventListener('click', () => this.setQty(this.qty - 1));
        this.plusBtn && this.plusBtn.addEventListener('click', () => this.setQty(this.qty + 1));
        this.input &&
          this.input.addEventListener('change', () => this.setQty(parseInt(this.input.value, 10) || 1));

        this.setQty(this.qty);
      }

      setQty(next) {
        this.qty = Math.max(1, Math.min(this.max, next));
        if (this.input) this.input.value = this.qty;
        if (this.minusBtn) this.minusBtn.disabled = this.qty <= 1;
        if (this.plusBtn) this.plusBtn.disabled = this.qty >= this.max;
      }

      onClick(evt) {
        evt.preventDefault();
        if (this.button.classList.contains('loading')) return;

        const cart =
          document.querySelector('cart-drawer') || document.querySelector('cart-notification');

        this.button.classList.add('loading');
        this.button.setAttribute('aria-disabled', 'true');
        const spinner = this.querySelector('.loading-overlay__spinner');
        if (spinner) spinner.classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData();
        formData.append('id', this.variantId);
        formData.append('quantity', this.qty);
        formData.append('properties[_addon]', 'friends-family');

        if (cart) {
          formData.append('sections', cart.getSectionsToRender().map((section) => section.id));
          formData.append('sections_url', window.location.pathname);
          cart.setActiveElement && cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              console.error('cart-addon add error:', response.description || response.message);
              return;
            }
            if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'cart-addon',
                productVariantId: this.variantId,
              });
            }
            if (cart && cart.renderContents) {
              cart.renderContents(response);
            } else {
              window.location = window.routes.cart_url;
            }
          })
          .catch((e) => console.error(e))
          .finally(() => {
            this.button.classList.remove('loading');
            this.button.removeAttribute('aria-disabled');
            if (spinner) spinner.classList.add('hidden');
          });
      }
    }
  );
}
